import React from "react";
import "./Testimonials.css";

const videos = [
  {
    id: 1,
    number: "01",
    title: "JAM Session",
    brand: "PRT Academy",
    description:
      "Students developing confidence and communication skills through JAM sessions.",
    src: "/videos/JAMSession1.mp4",
  },
  {
    id: 2,
    number: "02",
    title: "Group Discussion",
    brand: "PRT Academy",
    description:
      "Students practicing teamwork, communication and professional discussion skills.",
    src: "/videos/GroupDiscussion1.mp4",
  },
  {
    id: 3,
    number: "03",
    title: "Mock Interview",
    brand: "PRT Academy",
    description:
      "Students preparing for technical and HR interview situations.",
    src: "/videos/MockInterview1.mp4",
  },
];

const Testimonials = () => {
  return (
    <section className="testimonials">

      {/* ================= HEADER ================= */}

      <div className="testimonials-header">

        <span className="testimonials-badge">
          STUDENT ACTIVITIES
        </span>

        <h2 className="testimonials-title">
          Experience Learning Through
          <span> Real Practice</span>
        </h2>

        <p className="testimonials-description">
          At PRT Academy, students get opportunities to practice communication,
          teamwork and interview skills through real classroom activities.
        </p>

      </div>


      {/* ================= VIDEO CARDS ================= */}

      <div className="testimonials-container">

        {videos.map((video) => (

          <article
            key={video.id}
            className="video-card"
          >

            {/* ================= VIDEO ================= */}

            <div className="video-wrapper">

              <video
                src={video.src}
                className="video-preview"
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
                disablePictureInPicture
                controlsList="nodownload nofullscreen noremoteplayback"
              >
                Your browser does not support the video tag.
              </video>


              {/* ================= NUMBER ================= */}

              <span className="video-number">
                {video.number}
              </span>


              {/* ================= OVERLAY ================= */}

              <div className="video-overlay"></div>

            </div>


            {/* ================= VIDEO CONTENT ================= */}

            <div className="video-label">

              <span className="video-brand">
                {video.brand}
              </span>

              <h3 className="video-title">
                {video.title}
              </h3>

              <p className="video-description">
                {video.description}
              </p>

            </div>

          </article>

        ))}

      </div>


      {/* ================= BOTTOM MESSAGE ================= */}

      <div className="testimonials-bottom">

        <div className="testimonials-bottom-content">

          <span>
            PRT ACADEMY
          </span>

          <h3>
            Practice. Communicate.
            <strong> Build Confidence.</strong>
          </h3>

        </div>

        <p>
          Regular practice helps students become more confident in
          communication, teamwork and professional situations.
        </p>

      </div>

    </section>
  );
};

export default Testimonials;